import { IBaseLabelValue, IInquiryDetailsResultValues } from "@/interfaces";
import { cn } from "@/lib";

interface IResultContentProps {
  content: IBaseLabelValue[] | IInquiryDetailsResultValues[];
  className?: string;
  title?: string;
  forPdf?: boolean;
}

const ResultContent: React.FC<IResultContentProps> = ({
  content,
  className,
  forPdf = false,
  title,
}) => {
  return (
    <>
      <ul
        className={cn(
          "mb-10 flex flex-col gap-6 rounded-xl p-4 py-8 sm:p-8",
          className,
          forPdf ? "border" : "shadow-main",
        )}
        style={{ border: forPdf ? "1px solid #ccc" : "none" }}
      >
        {title && (
          <li className="mb-2">
            <span className="text-base font-semibold lg:text-lg">{title}</span>
          </li>
        )}
        {content.map((item, index) => (
          <li
            key={index}
            className={cn(
              "flex-between items-start gap-6 text-xs sm:text-sm md:gap-8 lg:text-base",
              item.value === "-" ? "hidden" : "flex",
            )}
          >
            <span className="min-w-max">{item.label}</span>
            <span className="text-start" style={{ color: "#5a2bd2" }}>
              {item.value}
            </span>
          </li>
        ))}
      </ul>
    </>
  );
};

export default ResultContent;
